// extracted by mini-css-extract-plugin
module.exports = {"suggestions-list-wrapper":"styles_suggestions-list-wrapper__1OxYk","suggestion":"styles_suggestion__2YqkR"};